<div>
  <nav
    class="navbar navbar-expand-lg navbar-light py-3 position-sticky top-0 z-3"
    style="background-color: #141ed2"
  >
    <div class="container">
      <div>
        <a class="navbar-brand text-black-50" href="#">
          <img
            loading="lazy"
            src="assets/images/Logo_LoathanhtoanMB1.png"
            alt="Logo"
            height="40"
          />
        </a>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mt-2" *ngIf="sectionValue === 0">
            <a class="nav-link" href="#process-steps">Cách hoạt động</a>
          </li>
          <li class="nav-item mt-2" *ngIf="sectionValue === 0">
            <a class="nav-link" href="#solution-package-section">Giải pháp</a>
          </li>
          <li class="nav-item mt-2" *ngIf="sectionValue === 0">
            <a class="nav-link" href="#package-section">Khách hàng</a>
          </li>
          <li class="nav-item mt-2" *ngIf="sectionValue === 0">
            <a class="nav-link" href="#question">FAQ</a>
          </li>
          <li class="nav-item mt-2">
            <button
              class="btn bg-white text-primary btn-lg rounded-4"
              style="margin-top: -0.3rem"
            >
              <a href="tel:1900998893" class="font-weight-bolder text-primary">
                1900 99.88.93
              </a>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <section
    id="hero-section"
    class="section-div solution-package-section py-4 bg-content"
    *ngIf="sectionValue === 0"
  >
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="font-weight-bold">Loa thanh toán</h1>
          <h3>Ting ting vào ví - Buôn bán như ý</h3>
          <p class="lead mt-4">
            Loa thông báo tiền về giúp người bán hàng xác nhận thanh toán
            <span class="highlight-text">nhanh chóng, an toàn</span> mà không
            cần kiểm tra điện thoại
          </p>
          <div class="mt-4">
            <button
              class="listen-button"
              class="btn btn-outline-primary btn-lg mr-3"
              [ngClass]="{ playing: isPlaying }"
              (click)="playAudio()"
            >
              <img
                loading="lazy"
                loading="lazy"
                [src]="
                  isPlaying
                    ? 'https://cdn.builder.io/api/v1/image/assets/TEMP/73a4d5b7674bd782f322781ffb0a0975f4e938cdd00fb12a49694fe07a1372d4?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb'
                    : 'https://cdn.builder.io/api/v1/image/assets/TEMP/6d87a1901c603907f22af955c5a7df72557bc9246325c9f0166e9cfbb386a10e?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb'
                "
                alt=""
                class="button-icon"
              />
              <span class="button-text">{{
                isPlaying ? "Đang phát" : "Nghe thử"
              }}</span>
            </button>
            <button class="btn btn-primary btn-lg" (click)="nextSection()">
              Đăng ký ngay
            </button>
          </div>
        </div>
        <div class="col-md-6 text-center">
          <img
            loading="lazy"
            src="assets/images/landing.png"
            alt="Loa Thanh Toán"
            class="img-fluid"
          />
        </div>
        <div class="row m-0">
          <div class="col-6 col-md-3">
            <div class="bg-light text-left pl-2 p-1 rounded-3">
              <div class="mb-2">
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/e3344d125c957e4d301974b23b3ba4ce42b758686227cee4faee35d2022ea143?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt="Information icon"
                  class="icon-image"
                />
              </div>
              <h3 class="fw-bold text-primary m-0">
                <span class="font-size-24">0</span> đồng
              </h3>
              <p class="small font-size-15">Phí mua thiết bị</p>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="bg-light text-left pl-2 p-1 rounded-3">
              <div class="mb-2">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/a994e68677042cc1ae8fd5df93379a3df38eb1f749c2947b656131e373f2b15c?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="feature-icon"
                />
              </div>
              <h3 class="fw-bold text-primary m-0">
                <span class="font-size-24">1</span> đổi
                <span class="font-size-24">1</span>
              </h3>
              <p class="small font-size-15">Bảo hành trọn đời</p>
            </div>
          </div>

          <div class="col-6 col-md-3 mt-3 mt-md-0">
            <div class="bg-light text-left pl-2 p-1 rounded-3">
              <div class="mb-1">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/58cb95ee3147b096fc32f4983a6c9097189d357b2ec7d4399265ab955c8d6d6f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="feature-icon"
                />
              </div>
              <h3 class="fw-bold text-primary m-0">
                <span class="font-size-24">2</span> ngày pin
              </h3>
              <p class="small font-size-15 mb-0">
                Dùng thoải mái, không lo ngắt quãng
              </p>
            </div>
          </div>
          <div class="col-6 col-md-3 mt-3 mt-md-0">
            <div class="bg-light text-left pl-2 p-1 rounded-3">
              <div class="mb-2">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/9bfdaf08a64f7466d42127639c086623929c75230769bd25e889ba4b27f1d992?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="feature-icon"
                />
              </div>
              <h3 class="fw-bold text-primary m-0">
                <span class="font-size-24">3</span> bước
              </h3>
              <p class="small font-size-15">Đăng ký và nhận loa</p>
            </div>
          </div>
        </div>
      </div>
      <section id="process-steps" class="process-steps text-center py-5">
        <h2 class="mb-5">Cách hoạt động của Loa thanh toán</h2>

        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 text-center images-section-2">
              <img
                loading="lazy"
                src="assets/images/loa_wifi.png"
                alt="Loa Thanh Toán"
                class="img-fluid"
              />
            </div>
            <div class="col-md-6">
              <div class="bg-light rounded-5 col-md-12 p-3 mb-3 font-size-18">
                <h3>01.</h3>
                Khách hàng quét QR bằng ứng dụng Mobile Banking của bất kì ngân
                hàng nào
              </div>
              <div class="bg-light rounded-5 col-md-12 p-3 font-size-18 mb-3">
                <h3>02.</h3>
                Khách hàng xác nhận thanh toán
              </div>
              <div class="bg-light rounded-5 col-md-12 p-3 font-size-18">
                <h3>03.</h3>
                Loa thông báo đã nhận được tiền
              </div>
              <button
                class="btn btn-primary btn-lg mt-2"
                (click)="nextSection()"
              >
                Đăng ký ngay
              </button>
            </div>
          </div>
        </div>
      </section>
      <section id="solution-package-section" class="text-center py-5">
        <h2 class="mb-2">Nhận trọn bộ giải pháp Loa Thanh Toán</h2>
        <h3>Chỉ từ 37.222đ/tháng</h3>
        <div>
          <div class="row justify-content-center mt-3">
            <div class="col-md package-item">
              <h4>Bộ sản phẩm Loa Thanh Toán</h4>
              <ul>
                <li>Loa báo kết quả giao dịch</li>
                <li>QR Code thanh toán in sẵn</li>
                <li>Cáp sạc đi kèm</li>
                <li>Sim data 4G đã kích hoạt</li>
              </ul>
              <img
                loading="lazy"
                src="assets/images/loa_wifi.png"
                alt="Logo"
                height="175rem"
              />
            </div>
            <div class="col-md package-item">
              <h4>Ứng dụng quản lý và báo cáo tiền về</h4>
              <ul>
                <li>Theo dõi doanh thu ngay trên app MBBank</li>
                <li>Quản lý QR nhận tiền</li>
                <li>Xem và so sánh doanh thu theo thời gian</li>
                <li>Báo cáo chi tiết về tài chính cửa hàng</li>
              </ul>
              <img
                loading="lazy"
                src="assets/images/img-price-card.png"
                alt="Logo"
                height="175rem"
              />
            </div>
          </div>
        </div>
        <button class="btn btn-primary btn-lg" (click)="nextSection()">
          Đăng ký ngay
        </button>
      </section>
      <section id="package-section" class="text-center py-5">
        <h2 class="mb-2">
          Loa Thanh Toán phù hợp với đa dạng loại hình kinh doanh
        </h2>
        <div class="container">
          <div class="d-md-flex justify-content-around mt-4">
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-medical-bag"></span>
              </div>
              <p>Nhà thuốc</p>
            </div>
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-face-woman-outline"></span>
              </div>
              <p>Dịch vụ làm đẹp</p>
            </div>
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-silverware"></span>
              </div>
              <p>Quán ăn</p>
            </div>
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-coffee"></span>
              </div>
              <p>Tiệm cà phê</p>
            </div>
          </div>
          <div class="d-md-flex justify-content-around mt-4">
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-storefront-outline"></span>
              </div>
              <p>Tạp hóa</p>
            </div>
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-cart-outline"></span>
              </div>
              <p>Siêu thị</p>
            </div>
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-store"></span>
              </div>
              <p>Cửa hàng</p>
            </div>
            <div class="item-categories" (click)="nextSection()">
              <div class="bg-light width-img p-3 mb-2 rounded-circle">
                <span class="mdi mdi-food-fork-drink"></span>
              </div>
              <p>Thực phẩm</p>
            </div>
          </div>
        </div>
      </section>
      <section id="question" class="solution-package-section text-center">
        <h2 class="mb-2">Hỏi và đáp về Loa Thanh Toán</h2>
        <div class="container">
          <div>
            <mat-accordion class="mt-3 d-md-flex justify-content-center">
              <mat-expansion-panel
                class="p-2 rounded-5 w-100"
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title> Loa Thanh Toán là gì? </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="text-left">
                  <a class="text-primary" (click)="nextSection()"
                    >Loa Thanh Toán</a
                  >
                  là thiết bị phát âm thanh bằng giọng nói, thông báo kết quả
                  thanh toán qua mã QR. Khi giao dịch thành công, loa sẽ tự động
                  đọc chính xác số tiền khách hàng đã chuyển khoản, giúp người
                  bán nhận tiền nhanh chóng và an toàn.
                </p>
              </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion class="mt-3 d-md-flex justify-content-center">
              <mat-expansion-panel
                class="p-2 rounded-5 w-100"
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Tôi muốn đăng ký sử dụng sản phẩm này
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="text-left">
                  Hãy điền thông tin vào form đăng ký
                  <a class="text-primary" (click)="nextSection()">Tại đây</a>
                  hoặc liên hệ hotline 0869.1988.93 hoặc hỗ trợ qua Email
                  <a href="mailto:info@tomotek.vn">info&#64;tomotek.vn</a>
                </p>
              </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion class="mt-3 d-md-flex justify-content-center">
              <mat-expansion-panel
                class="p-2 rounded-5 w-100"
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Thiết bị này có an toàn không?
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="text-left">
                  Có. Thiết bị này do TOMOTEK phát triển cùng Ngân hàng TMCP
                  Quân Đội, đáp ứng các yêu cầu bảo mật quốc tế về an toàn bảo
                  mật thanh toán. Tất cả các giao dịch đều được đảm bảo an toàn
                </p>
              </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion class="mt-3 d-md-flex justify-content-center">
              <mat-expansion-panel
                class="p-2 rounded-5 w-100"
                (opened)="panelOpenState = true"
                (closed)="panelOpenState = false"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Tôi mất những chi phí gì để sử dụng Loa Thanh Toán?
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p class="text-left">
                  Khách hàng được tặng miễn phí Loa thanh toán khi đăng ký gói
                  dịch vụ chỉ từ
                  <a class="text-primary" (click)="nextSection()"
                    >37.222 đ/tháng.</a
                  >
                </p>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </section>
    </div>
  </section>

  <section
    class="section-div solution-package-section text-center py-4 container"
    *ngIf="sectionValue === 1"
  >
    <div class="">
      <section class="content-wrapper px-3 pt-3 text-center">
        <div class="text-left">
          <h2 class="fw-bold">Các gói dịch vụ Loa thanh toán</h2>
          <p class="m-0 font-size-15">
            Nhận ngay loa thanh toán miễn phí khi đăng ký gói dịch vụ
          </p>
        </div>
        <div class="row d-md-flex mb-5">
          <ng-container *ngFor="let product of products">
            <article
              class="card-product col-md-6"
              [class.active]="selectedProduct?.name === product.name"
              (click)="setActiveProduct(product)"
            >
              <div class="product-content">
                <img
                  loading="lazy"
                  (click)="selectProduct(product)"
                  [src]="product.src"
                  alt="{{ product.name }} product image"
                  class="product-image img-fluid"
                />
                <div class="product-details">
                  <h2 class="product-title">
                    {{ product.name === "wifi" ? "Loa Wifi" : "Loa 4G" }}
                  </h2>
                  <p class="product-description">
                    {{
                      product.name === "wifi"
                        ? "Loa sử dụng kết nối wifi"
                        : "Loa kết nối sim 4G"
                    }}
                  </p>
                  <p class="product-accessories">
                    {{
                      product.name === "wifi"
                        ? "Phụ kiện gồm dây sạc type C và
                      bảng mã QR"
                        : "Phụ kiện gồm dây sạc type C, bảng mã QR, sim
                      4G đã kích hoạt"
                    }}
                  </p>
                </div>
              </div>
              <div
                class="quantity-stepper"
                *ngIf="selectedProduct?.name === product.name"
              >
                <button
                  class="stepper-button"
                  aria-label="Decrease quantity"
                  (click)="
                    changeQuantity(product, -1); $event.stopPropagation()
                  "
                >
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6eb9af969ef8b6732e8769fbb384f8b17f21d751bb1d9649a679ff48a7443f6?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                    alt=""
                    class="stepper-icon"
                  />
                </button>
                <span class="quantity-amount" aria-live="polite">{{
                  quantities[product.name]
                }}</span>
                <button
                  class="stepper-button"
                  aria-label="Increase quantity"
                  (click)="changeQuantity(product, 1); $event.stopPropagation()"
                >
                  <img
                    loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/911a195508de5b43dfdef0a1906ef43fe9643542e750eff09f24c302715fd761?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                    alt=""
                    class="stepper-icon"
                  />
                </button>
              </div>
              <div
                class="checkbox-container"
                *ngIf="selectedProduct?.name === product.name"
              >
                <input
                  type="checkbox"
                  (change)="onCheckboxChange($event)"
                  class="checkbox"
                  [checked]="selectedProduct?.name === product.name"
                />
              </div>
            </article>
          </ng-container>
        </div>
        <section class="offer-container my-3 text-left">
          <h3 class="offer-text">
            🔥 Ưu đãi siêu hấp dẫn chỉ trong tháng {{ currentMonth }}
          </h3>
        </section>
        <div class="plan-cards-container row d-md-flex">
          <article
            class="plan-card border col-md"
            [class.popular]="item.tag === 'Phổ biến nhất'"
            [class.best-value]="item.tag === 'Tiết kiệm nhất'"
            [class.selected]="selectedPackageId === item.id"
            *ngFor="let item of packages"
            (click)="selectPackage(item)"
          >
            <div class="plan-content">
              <h2 class="plan-duration">{{ item.original_duration }} tháng</h2>
              <p class="plan-feature">{{ item.benefit }}</p>
              <p class="plan-bonus" *ngIf="item.bonus_duration">
                Tặng thêm
                <span class="bonus-months">
                  {{ item.bonus_duration }}
                  tháng
                </span>
              </p>
            </div>
            <div class="plan-pricing">
              <div class="original-price-container">
                <span class="original-price"
                  >{{ item.original_price | number : "1.0-0" }}
                  <ins>đ</ins>
                </span>
                <div class="strike-through"></div>
              </div>
              <span class="discounted-price"
                >{{ item.discounted_price | number : "1.0-0" }}
                <ins>đ</ins>
              </span>
              <span class="price-per-month"
                >({{ item.price_per_month | number : "1.0-0" }}
                <ins>đ</ins>
                /tháng)</span
              >
            </div>
            <span *ngIf="item.tag === 'Phổ biến nhất'" class="popular-tag"
              >Phổ biến nhất</span
            >
            <span *ngIf="item.tag === 'Tiết kiệm nhất'" class="best-value-tag"
              >Tặng thêm 50%, tiết kiệm nhất</span
            >
          </article>
        </div>
        <div class="text-left mb-3">
          <span style="font-size: 0.8rem"
            ><span style="color: red; font-weight: bold">*</span>Giá các gói
            dịch vụ đã bao gồm VAT
          </span>
        </div>
      </section>
    </div>
  </section>
  <section
    class="section-div solution-package-section text-center py-4"
    *ngIf="sectionValue === 2"
  >
    <div class="container">
      <section class="text-left">
        <form class="order-form d-md-flex" [formGroup]="orderForm">
          <section class="order-summary col-md-4 mr-2">
            <div class="text-left mb-3">
              <h2 class="ms-2 mb-2 fw-bold">Thông tin giao hàng</h2>
              <p class="ms-2 mb-0">Bạn vui lòng điền thông tin của bạn</p>
            </div>
            <section class="card">
              <header class="card-header">
                <img
                  [src]="selectedProduct.src"
                  [alt]="selectedProduct.name"
                  class="product-image"
                />
                <div class="product-details">
                  <div class="product-info">
                    <h2 class="product-name">
                      {{
                        selectedProduct.name === "wifi" ? "Loa Wifi" : "Loa 4G"
                      }}
                    </h2>
                    <span class="product-quantity mr-3"
                      >x{{ selectedProduct.quantity }}</span
                    >
                  </div>
                  <div class="product-pricing">
                    <span class="service-period">
                      Gói dịch vụ
                      <strong class="highlight"
                        >{{ selectedPackage?.original_duration }} tháng</strong
                      >
                    </span>
                    <span class="product-price">
                      {{
                        selectedPackage?.discounted_price | number : "1.0-0"
                      }}
                      VND
                    </span>
                  </div>
                </div>
              </header>
              <hr class="divider" />
              <div class="summary-row">
                <span>Tiền hàng</span>
                <span>
                  {{
                    selectedPackage?.discounted_price * selectedProduct.quantity
                      | number : "1.0-0"
                  }}
                  VND
                </span>
              </div>
              <div class="summary-row" *ngIf="serviceType === 'shipper'">
                <span>Phí giao hàng</span>
                <span>30,000 VND</span>
              </div>
              <hr class="divider solid" />
              <div class="summary-row total">
                <span>Thành tiền</span>
                <span class="highlight">
                  {{
                    selectedPackage?.discounted_price *
                      selectedProduct.quantity +
                      (serviceType === "shipper" ? 30000 : 0) | number : "1.0-0"
                  }}
                  VND
                </span>
              </div>
            </section>
          </section>

          <div class="order-summary col-md-7">
            <section class="store-info" formGroupName="storeInfo">
              <h2 class="section-title text-left">Thông tin cửa hàng</h2>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/b747068bdaff285b4c0b598eae2550df6ccb62a982e33f35b7eabcab01c462e7?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Tên cửa hàng</mat-label>
                  <input
                    matInput
                    formControlName="storeName"
                    required
                    (input)="onInputChange($event, 'storeName')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.storeName').invalid &&
                      (orderForm.get('storeInfo.storeName').touched ||
                        orderForm.get('storeInfo.storeName').dirty)
                    "
                  >
                    Tên cửa hàng là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4961fecc01ee785d0bbf7d225ff229e29e5f7d0e204a74b9eb718efa0946f95d?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Số điện thoại cửa hàng</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="terminalPhone"
                    required
                    (input)="onInputChange($event, 'terminalPhone')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.terminalPhone').invalid &&
                      (orderForm.get('storeInfo.terminalPhone').touched ||
                        orderForm.get('storeInfo.terminalPhone').dirty)
                    "
                  >
                    <ng-container
                      *ngIf="
                        orderForm
                          .get('storeInfo.terminalPhone')
                          .hasError('required')
                      "
                    >
                      Số điện thoại cửa hàng là bắt buộc.
                    </ng-container>
                    <ng-container
                      *ngIf="
                        orderForm
                          .get('storeInfo.terminalPhone')
                          .hasError('pattern')
                      "
                    >
                      Số điện thoại cửa hàng không hợp lệ.
                    </ng-container>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <mat-form-field>
                  <mat-label>Tỉnh/thành phố</mat-label>
                  <mat-select
                    formControlName="province"
                    (selectionChange)="
                      onProvinceChange($event.value, 'storeInfo')
                    "
                    required
                  >
                    <mat-option
                      *ngFor="let province of listProvince"
                      [value]="province"
                    >
                      {{ province.PROVINCE_NAME }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.province').invalid &&
                      (orderForm.get('storeInfo.province').touched ||
                        orderForm.get('storeInfo.province').dirty)
                    "
                  >
                    Tỉnh/thành phố là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <mat-form-field>
                  <mat-label>Quận/huyện</mat-label>
                  <mat-select
                    formControlName="district"
                    (selectionChange)="
                      onDistrictChange($event.value, 'storeInfo')
                    "
                    required
                  >
                    <mat-option
                      *ngFor="let district of listDistrict"
                      [value]="district"
                    >
                      {{ district.DISTRICT_NAME }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.district').invalid &&
                      (orderForm.get('storeInfo.district').touched ||
                        orderForm.get('storeInfo.district').dirty)
                    "
                  >
                    Quận/huyện là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <mat-form-field>
                  <mat-label>Phường/xã</mat-label>
                  <mat-select formControlName="ward" required>
                    <mat-option *ngFor="let ward of listWard" [value]="ward">
                      {{ ward.WARDS_NAME }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.ward').invalid &&
                      (orderForm.get('storeInfo.ward').touched ||
                        orderForm.get('storeInfo.ward').dirty)
                    "
                  >
                    Phường/xã là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/a24af1b7a5113f1d1d02150c4ec757a1d4892b18490fa41dad044b3bd0023a26?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Địa chỉ</mat-label>
                  <input
                    matInput
                    formControlName="storeAddress"
                    required
                    (input)="onInputChange($event, 'storeAddress')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.storeAddress').invalid &&
                      (orderForm.get('storeInfo.storeAddress').touched ||
                        orderForm.get('storeInfo.storeAddress').dirty)
                    "
                  >
                    Địa chỉ là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/8795d34e354a4ea4c2f1e673f1b6b70614e105214919bea0ffb38ff3145fb12c?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Số tài khoản QR (MB Bank)</mat-label>
                  <input
                    matInput
                    formControlName="qrAccount"
                    required
                    (focusout)="onInputBlur()"
                    (input)="onInputChange($event, 'qrAccount')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.qrAccount').invalid &&
                      (orderForm.get('storeInfo.qrAccount').touched ||
                        orderForm.get('storeInfo.qrAccount').dirty)
                    "
                  >
                    Số tài khoản QR là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/7bb4f99945c16a3c8e91b6a3f62fbca6b91ef06abf65b617ca4e317da6965d2f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Chủ tài khoản</mat-label>
                  <input
                    matInput
                    formControlName="accountOwner"
                    readonly
                    required
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('storeInfo.accountOwner').invalid &&
                      (orderForm.get('storeInfo.accountOwner').touched ||
                        orderForm.get('storeInfo.accountOwner').dirty)
                    "
                  >
                    Chủ tài khoản là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
            </section>

            <!-- Thông Tin Người Nhận (Nếu Có Shipper) -->
            <section
              class="recipient-info"
              *ngIf="serviceType === 'shipper'"
              formGroupName="shippingInfo"
            >
              <h2 class="section-title text-left">Thông tin người nhận</h2>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/7bb4f99945c16a3c8e91b6a3f62fbca6b91ef06abf65b617ca4e317da6965d2f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Tên người nhận</mat-label>
                  <input
                    matInput
                    formControlName="recipientName"
                    required
                    (input)="onInputChange($event, 'recipientName')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('shippingInfo.recipientName').invalid &&
                      (orderForm.get('shippingInfo.recipientName').touched ||
                        orderForm.get('shippingInfo.recipientName').dirty)
                    "
                  >
                    <ng-container
                      *ngIf="
                        orderForm
                          .get('shippingInfo.recipientName')
                          .hasError('required')
                      "
                    >
                      Tên người nhận là bắt buộc.
                    </ng-container>
                    <ng-container
                      *ngIf="
                        orderForm
                          .get('shippingInfo.recipientName')
                          .hasError('noIcons')
                      "
                    >
                      Tên người nhận không được chứa ký tự đặc biệt.
                    </ng-container>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/4961fecc01ee785d0bbf7d225ff229e29e5f7d0e204a74b9eb718efa0946f95d?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Số điện thoại</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="recipientPhone"
                    required
                    (input)="onInputChange($event, 'recipientPhone')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('shippingInfo.recipientPhone').invalid &&
                      (orderForm.get('shippingInfo.recipientPhone').touched ||
                        orderForm.get('shippingInfo.recipientPhone').dirty)
                    "
                  >
                    <ng-container
                      *ngIf="
                        orderForm
                          .get('shippingInfo.recipientPhone')
                          .hasError('required')
                      "
                    >
                      Số điện thoại là bắt buộc.
                    </ng-container>
                    <ng-container
                      *ngIf="
                        orderForm
                          .get('shippingInfo.recipientPhone')
                          .hasError('pattern')
                      "
                    >
                      Số điện thoại không hợp lệ.
                    </ng-container>
                  </mat-error>
                </mat-form-field>
              </div>
            </section>

            <!-- Nút Chuyển Đổi Địa Chỉ -->
            <section class="recipient-info" *ngIf="serviceType === 'shipper'">
              <div
                class="d-flex align-items-center justify-content-between p-2"
              >
                <span>Thông tin giao hàng trùng với thông tin cửa hàng</span>
                <label class="switch">
                  <input
                    type="checkbox"
                    [(ngModel)]="isChecked"
                    (ngModelChange)="toggleSwitch($event)"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <span class="slider"></span>
                </label>
              </div>
            </section>

            <!-- Địa Chỉ Nhận Hàng (Nếu Không Trùng Với Cửa Hàng) -->
            <section
              class="shipping-address"
              *ngIf="serviceType === 'shipper' && !isChecked"
              formGroupName="shippingInfo"
            >
              <h2 class="section-title">Địa chỉ nhận hàng</h2>
              <div class="input-group">
                <mat-form-field>
                  <mat-label>Tỉnh/thành phố</mat-label>
                  <mat-select
                    formControlName="province"
                    (selectionChange)="
                      onProvinceChange($event.value, 'shippingInfo')
                    "
                    required
                  >
                    <mat-option
                      *ngFor="let province of listProvince"
                      [value]="province"
                    >
                      {{ province.PROVINCE_NAME }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      orderForm.get('shippingInfo.province').invalid &&
                      (orderForm.get('shippingInfo.province').touched ||
                        orderForm.get('shippingInfo.province').dirty)
                    "
                  >
                    Tỉnh/thành phố là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <mat-form-field>
                  <mat-label>Quận/huyện</mat-label>
                  <mat-select
                    formControlName="district"
                    (selectionChange)="
                      onDistrictChange($event.value, 'shippingInfo')
                    "
                    required
                  >
                    <mat-option
                      *ngFor="let district of listDistrict"
                      [value]="district"
                    >
                      {{ district.DISTRICT_NAME }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      orderForm.get('shippingInfo.district').invalid &&
                      (orderForm.get('shippingInfo.district').touched ||
                        orderForm.get('shippingInfo.district').dirty)
                    "
                  >
                    Quận/huyện là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <mat-form-field>
                  <mat-label>Phường/xã</mat-label>
                  <mat-select formControlName="ward" required>
                    <mat-option *ngFor="let ward of listWard" [value]="ward">
                      {{ ward.WARDS_NAME }}
                    </mat-option>
                  </mat-select>
                  <mat-error
                    *ngIf="
                      orderForm.get('shippingInfo.ward').invalid &&
                      (orderForm.get('shippingInfo.ward').touched ||
                        orderForm.get('shippingInfo.ward').dirty)
                    "
                  >
                    Phường/xã là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/a24af1b7a5113f1d1d02150c4ec757a1d4892b18490fa41dad044b3bd0023a26?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                  alt=""
                  class="input-icon"
                />
                <mat-form-field>
                  <mat-label>Địa chỉ</mat-label>
                  <input
                    matInput
                    formControlName="address"
                    required
                    (input)="onInputChange($event, 'address')"
                  />
                  <mat-error
                    *ngIf="
                      orderForm.get('shippingInfo.address').invalid &&
                      (orderForm.get('shippingInfo.address').touched ||
                        orderForm.get('shippingInfo.address').dirty)
                    "
                  >
                    Địa chỉ là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </div>
            </section>

            <!-- Phần Xác Nhận Điều Khoản -->
            <section class="payment-confirmation mt-3 mb-5">
              <div class="terms-agreement">
                <input
                  type="checkbox"
                  id="termsCheckbox"
                  [checked]="isTermsAgreed"
                  (change)="onCheckboxChange($event)"
                />
                <label class="checkbox-label font-weight-normal">
                  Tôi đã đọc và đồng ý với
                  <span
                    class="highlight-text"
                    data-bs-toggle="modal"
                    data-bs-target="#chooseConditions"
                    >Điều khoản Dịch vụ & Chính sách Bảo hành</span
                  >
                </label>
              </div>
            </section>
          </div>
        </form>
      </section>
    </div>
  </section>
  <section
    class="section-div solution-package-section text-center py-4"
    *ngIf="sectionValue === 3"
  >
    <div class="container py-4">
      <div class="row align-items-start">
        <div class="col-md-6 text-center mb-4 mb-md-0">
          <h4 class="mb-3">Quét mã QR để thanh toán</h4>
          <div class="qr-wrapper position-relative d-inline-block">
            <qr-code
              class="border shadow-sm rounded"
              [value]="dataOrder?.qr_string"
              [size]="300"
              [errorCorrectionLevel]="'M'"
            ></qr-code>

            <img
              src="assets/images/logoMB.png"
              alt="Logo"
              class="qr-center-logo"
            />
          </div>

          <p class="mt-2 text-muted font-italic small">
            Sử dụng app ngân hàng để quét mã
          </p>
          <div class="mt-3 text-center">
            <div *ngIf="paymentStatus !== 'success'" class="text-muted small">
              <div
                class="spinner-border spinner-border-sm text-primary me-2"
                role="status"
              ></div>
              Đang chờ thanh toán...
            </div>

            <div
              *ngIf="paymentStatus === 'success'"
              class="text-success fw-bold"
            >
              ✅ Thanh toán thành công!
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <h4 class="mb-3">Thông tin đơn hàng</h4>
          <section class="order-summary">
            <section class="card">
              <header class="card-header">
                <img
                  [src]="selectedProduct.src"
                  [alt]="selectedProduct.name"
                  class="product-image"
                />
                <div class="product-details">
                  <div class="product-info">
                    <h2 class="product-name">
                      {{
                        selectedProduct.name === "wifi"
                          ? "Loa Wifi"
                          : "Loa
                4G"
                      }}
                    </h2>
                    <span class="product-quantity mr-3"
                      >x{{ selectedProduct.quantity }}</span
                    >
                  </div>
                  <div class="product-pricing">
                    <span class="service-period">
                      Gói dịch vụ
                      <strong class="highlight"
                        >{{ selectedPackage?.original_duration }} tháng</strong
                      >
                    </span>
                    <span class="product-price"
                      >{{
                        selectedPackage?.discounted_price | number : "1.0-0"
                      }}
                      VND</span
                    >
                  </div>
                </div>
              </header>
              <hr class="divider" />
              <div class="summary-row">
                <span>Tiền hàng</span>
                <span
                  >{{
                    selectedPackage?.discounted_price * selectedProduct.quantity
                      | number : "1.0-0"
                  }}
                  VND
                </span>
              </div>
              <div class="summary-row" *ngIf="serviceType === 'shipper'">
                <span>Phí giao hàng</span>
                <span>30,000 VND</span>
              </div>
              <hr class="divider solid" />
              <div class="summary-row total">
                <span>Thành tiền</span>
                <span class="highlight">
                  {{
                    selectedPackage?.discounted_price *
                      selectedProduct.quantity +
                      (serviceType === "shipper" ? 30000 : 0)
                      | number : "1.0-0"
                  }}VND</span
                >
              </div>
            </section>

            <div class="text-center mt-4" *ngIf="paymentStatus != 'success'">
              <button class="btn-viettel">Tôi đã thanh toán</button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
  <footer
    *ngIf="sectionValue === 0; else Redirect"
    style="margin-top: 25rem"
    class="position-absolute bottom-0 left-0 bg-dark text-white w-100 pt-4"
  >
    <div class="container">
      <div class="row d-md-flex justify-content-md-between">
        <div class="col-md-4 order-md-2 text-center">
          <img
            loading="lazy"
            src="assets/images/Logo_LoathanhtoanMB1.png"
            alt="Loa Thanh Toán"
            class="img-fluid w-100"
          />
        </div>
        <div class="col-md-4 order-md-1">
          <p class="company-info">
            CÔNG TY CỔ PHẦN TOMOTEK<br />
            <br />
            MST: 0110084605
          </p>
          <!-- <img
              loading="lazy"
              src="assets/images/bct-hanggia.png"
              alt="Loa Thanh Toán"
              class="img-fluid w-20"
            /> -->
          <div class="company-info">
            <img
              loading="lazy"
              src="assets/images/bocongthuong.png"
              alt="Loa Thanh Toán"
              class="img-fluid"
            />
          </div>
        </div>
        <div class="col-md-4 order-md-3">
          <div class="contact-options">
            <a href="tel:1900998893" class="contact-option">
              <i class="fas fa-phone mr-2"></i>
              CSKH: 1900 99.88.93
            </a>
            <a href="tel:0869198893" class="contact-option">
              <i class="fas fa-phone mr-2"></i>
              Zalo: 0869.1988.93
            </a>
            <a href="mailto:loathanhtoan247@tomotek.vn" class="contact-option">
              <i class="fas fa-envelope mr-2"></i>
              loathanhtoan247&#64;tomotek.vn
            </a>
            <div class="text-end">
              <a
                href="https://www.facebook.com/people/Loa-thanh-to%C3%A1n-MB/61568382606156/"
                class="social-icon ml-2"
                ><i class="fab fa-facebook"></i
              ></a>
            </div>
          </div>
        </div>
        <div class="footer-bottom mt-4 text-center">
          <p>&copy; 2024 Tomotek. All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</div>
<ng-template #Redirect>
  <footer
    *ngIf="sectionValue != 3"
    class="position-fixed bottom-0 left-0 bg-dark text-white w-100"
  >
    <div class="container">
      <div class="d-flex justify-content-between align-items-center my-3">
        <button
          class="custom-button-back"
          (click)="previousSection()"
          aria-label="Quay lại"
        >
          Quay lại
        </button>

        <button
          class="custom-button"
          (click)="nextSection()"
          aria-label="Tiếp tục"
        >
          Tiếp tục
        </button>
      </div>
    </div>
  </footer>
</ng-template>
<div
  #chooseDetails
  class="modal fade"
  id="chooseDetails"
  tabindex="-1"
  aria-labelledby="chooseDetailsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="delivery-modal">
      <header class="delivery-header">
        <h2 class="delivery-title text-capitalize">
          Loa {{ selectedProduct.name === "wifi" ? "WIFI" : "4G" }}
        </h2>
        <button
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </header>
      <main class="text-center">
        <div class="image-container">
          <div
            *ngIf="selectedProduct.name === 'wifi'; else template4g"
            id="wifiCarousel"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="assets/images/loa_wifi.png"
                  alt="Loa WIFI"
                  class="d-block product-image-modal img-fluid"
                />
              </div>
              <div class="carousel-item">
                <img
                  src="assets/images/loa_4g.png"
                  alt="Loa WIFI QR"
                  class="d-block product-image-modal img-fluid"
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#wifiCarousel"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#wifiCarousel"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>

          <ng-template #template4g>
            <img
              loading="lazy"
              src="assets/images/loa_4g.png"
              alt="Loa 4G"
              class="product-image-modal img-fluid"
            />
          </ng-template>
        </div>

        <p>
          {{
            selectedProduct.name === "wifi"
              ? "Loa sử dụng kết nối wifi"
              : "Loa
            kết nối sim 4G"
          }}
        </p>
        <p>
          {{
            selectedProduct.name === "wifi"
              ? "Phụ kiện gồm dây sạc type C và
            bảng mã QR"
              : "Phụ kiện gồm dây sạc type C, bảng mã QR, sim 4G đã kích
            hoạt"
          }}
        </p>
      </main>
    </div>
  </div>
</div>

<div
  #chooseConditions
  class="modal fade bottom-modal mw-100"
  id="chooseConditions"
  tabindex="-1"
  aria-labelledby="chooseConditionsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="modal-content" style="border-radius: 1rem">
      <section class="delivery-modal">
        <header class="modal-header">
          <h2 class="modal-title">Điều khoản và điều kiện</h2>
          <button
            class="close-button"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/97a7253f394325dd307cb69b66b6c2a5d4f713d8a927da55219b908ade8639d6?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
              alt=""
              class="close-icon"
            />
          </button>
        </header>
        <main class="modal-content-2 pt-0 px-2 pb-0 border-0">
          <h4>ĐIỀU 1 - GIẢI THÍCH TỪ NGỮ</h4>
          <ol>
            <li>
              <strong>Đơn vị cung cấp dịch vụ:</strong> Là Công ty CP Tomotek
              (Tomotek).
            </li>
            <li>
              <strong>Khách hàng (KH):</strong> Là cá nhân, hộ kinh doanh đăng
              ký sử dụng dịch vụ của đơn vị cung cấp dịch vụ.
            </li>
            <li><strong>MB:</strong> Ngân hàng TMCP Quân đội.</li>
            <li>
              <strong>Tài khoản thanh toán (TKTT):</strong> Là tài khoản của KH
              tại MB.
            </li>
            <li>
              <strong>Dịch vụ thanh toán QR:</strong> Là dịch vụ thanh toán qua
              tài khoản làm phát sinh ghi có vào tài khoản KH đăng ký; Tomotek
              sẽ tự động tạo cho KH các mã thanh toán QR theo các thông tin của
              KH khai báo để nhận thanh toán vào tài khoản thanh toán của KH đã
              mở tại MB.
            </li>
            <li>
              <strong>Dịch vụ Loa thanh toán:</strong> Là dịch vụ thông báo biến
              động số dư bằng giọng nói kết quả giao dịch theo thời gian thực,
              giúp KH dễ dàng theo dõi kết quả giao dịch thanh toán QR thành
              công.
            </li>
            <li>
              <strong>Gói dịch vụ:</strong> Bao gồm các dịch vụ thanh toán QR và
              dịch vụ Loa thanh toán mà Tomotek cung cấp cho KH.
            </li>
            <li>
              <strong>Hủy ngang dịch vụ:</strong> Là trường hợp KH yêu cầu dừng
              gói dịch vụ trong quá trình đang sử dụng dịch vụ.
            </li>
          </ol>

          <h4>ĐIỀU 2 - NỘI DUNG DỊCH VỤ TOMOTEK CUNG CẤP</h4>
          <ol>
            <li>
              Tomotek cung cấp dịch vụ thanh toán qua QR, dịch vụ thông báo biến
              động số dư và dịch vụ loa thanh toán cho KH.
            </li>
            <li>
              Tomotek cung cấp phần cứng loa để phát ra thông báo biến động số
              dư bằng giọng nói cho KH.
            </li>
            <li>
              <strong>Phương thức hiển thị thông báo:</strong>
              <ul>
                <li>
                  Hiển thị ngay kết quả giao dịch thanh toán QR thành công trên
                  nền tảng của Tomotek (phần mềm/ứng dụng của Tomotek độc lập
                  và/hoặc miniApp của Tomotek tại MB).
                </li>
                <li>
                  Phát ra thông báo giao dịch ghi có qua QR bằng giọng nói từ
                  thiết bị loa do Tomotek cung cấp và đã kết nối cho KH thành
                  công.
                </li>
              </ul>
            </li>
            <li>
              <strong>Tần suất thông báo:</strong>
              <ul>
                <li>
                  Một lần ngay sau khi phát sinh giao dịch thanh toán chuyển
                  khoản bằng QR; và/hoặc
                </li>
                <li>
                  Theo cấu hình và yêu cầu của KH và phạm vi Tomotek đáp ứng
                  được.
                </li>
              </ul>
            </li>
          </ol>

          <h4>ĐIỀU 3 - CUNG CẤP THÔNG TIN VÀ XỬ LÝ DỮ LIỆU CÁ NHÂN</h4>
          <p>
            KH xác nhận đồng ý cung cấp thông tin của KH và thông tin của các
            giao dịch QR làm phát sinh ghi có tiền vào tài khoản của KH nhằm mục
            đích nhận diện KH, cập nhật trạng thái thành công của giao dịch trên
            nền tảng của Tomotek và/hoặc các thiết bị báo có bằng giọng nói được
            cung cấp bởi Tomotek cho KH.
          </p>

          <h4>ĐIỀU 4 - PHÍ DỊCH VỤ</h4>
          <ol>
            <li>
              Phí dịch vụ là các khoản phí KH phải trả cho Tomotek khi sử dụng
              dịch vụ mà Tomotek cung cấp.
            </li>
            <li>Phí dịch vụ được hiển thị là phí đã bao gồm VAT.</li>
            <li>
              Phí dịch vụ được thông báo và hiển thị cho KH khi đăng ký sử dụng
              dịch vụ.
            </li>
            <li>
              Phí dịch vụ sẽ không được hoàn trả cho KH trong trường hợp KH yêu
              cầu hủy ngang gói dịch vụ đã đăng ký.
            </li>
            <li>
              Biểu phí sử dụng dịch vụ do Tomotek quy định, có thể thay đổi theo
              từng thời kỳ phù hợp quy định của pháp luật và có giá trị hiệu lực
              với KH.
            </li>
            <li>
              <strong>Phương thức thu phí:</strong>
              <ul>
                <li>
                  <strong>Thanh toán phí lần đầu:</strong> Thực hiện trích nợ
                  TKTT của KH ngay thời điểm KH đăng ký dịch vụ.
                </li>
                <li>
                  <strong>Thanh toán phí gia hạn dịch vụ:</strong> Bằng việc
                  đồng ý sử dụng dịch vụ do Tomotek cung cấp, tùy thuộc vào loại
                  gói và thời gian gói dịch vụ, Tomotek áp dụng 1 khoản phí dịch
                  vụ cố định, được thu định kỳ 1 lần vào đầu kỳ. KH đồng ý về
                  việc TKTT của KH sẽ bị trích nợ để Tomotek thu phí dịch vụ và
                  đồng ý về việc thu phí này.
                </li>
              </ul>
            </li>
            <li>
              Phí chuyển phát nhanh (CPN) là phí giao thiết bị đến tay KH
              và/hoặc từ KH đến Tomotek khi phát sinh bảo hành sản phẩm.
            </li>
            <li>Phí dịch vụ chưa bao gồm phí chuyển phát nhanh cho KH.</li>
            <li>
              MB là đơn vị thực hiện thu hộ theo thỏa thuận hợp tác giữa MB và
              Tomotek. MB sẽ thực hiện thu phí KH theo chỉ định của Tomotek.
            </li>
          </ol>

          <h4>ĐIỀU 5 - THỜI HẠN CỦA GÓI DỊCH VỤ</h4>
          <ol>
            <li>
              Thời hạn Gói dịch vụ được Tomotek cung cấp bao gồm 03 tháng, 06
              tháng và 12 tháng. Thời hạn gói dịch vụ có thể được bổ sung, thay
              đổi theo chính sách Tomotek từng thời kỳ.
            </li>
            <li>
              Thời hạn của Gói dịch vụ được áp dụng tính từ ngày KH thanh toán
              thành công phí gói dịch vụ tương ứng cho tới ngày tương ứng của 03
              hoặc 06 hoặc 12 tháng kế tiếp (tùy theo gói dịch vụ KH lựa chọn
              khi đăng ký).
            </li>
            <li>
              KH có thể liên hệ với hotline của Tomotek hoặc thực hiện online
              trên nền tảng của Tomotek (nếu có) để hủy tính năng gia hạn tự
              động đối với gói dịch vụ đã đăng ký.
            </li>
          </ol>

          <h4>ĐIỀU 6 - CHẤM DỨT GÓI DỊCH VỤ</h4>
          <ol>
            <li>
              KH có thể chấm dứt sử dụng Gói dịch vụ bằng các cách sau:
              <ul>
                <li>
                  Hủy gia hạn bằng hotline hoặc tắt tính năng gia hạn gói dịch
                  vụ trên nền tảng mà Tomotek cung cấp.
                </li>
                <li>
                  KH liên hệ hotline để hủy dịch vụ ngay. Tomotek sẽ thực hiện
                  hủy dịch vụ cho KH tại thời điểm KH yêu cầu. Phí dịch vụ sẽ
                  không được hoàn trả.
                </li>
              </ul>
            </li>
          </ol>

          <h4>ĐIỀU 7 - THAY ĐỔI NỘI DUNG ĐIỀU KIỆN ĐIỀU KHOẢN</h4>
          <p>
            KH đồng ý rằng Tomotek có quyền thay đổi các điều khoản của bản Điều
            kiện Điều khoản này (“Bản điều khoản, điều kiện sửa đổi”). Tomotek
            sẽ thông báo tới KH bằng 1 trong các hình thức: (i) gửi thông báo
            bằng văn bản hoặc email hoặc SMS tới địa chỉ hoặc SĐT của KH đăng ký
            hoặc (ii) niêm yết tại website của Tomotek hoặc (iii) các hình thức
            khác do Tomotek quyết định.
          </p>

          <h4>
            ĐIỀU 8 - CHÍNH SÁCH GIAO HÀNG, ĐỔI TRẢ VÀ BẢO HÀNH PHẦN CỨNG LOA
            THANH TOÁN
          </h4>
          <ol>
            <li>
              <strong>Giao hàng:</strong>
              <ul>
                <li>
                  Tomotek có trách nhiệm giao phần cứng Loa thanh toán qua đơn
                  vị chuyển phát nhanh (CPN) đến KH theo địa chỉ mà KH đã đăng
                  ký.
                </li>
                <li>
                  Trong trường hợp đơn vị CPN không thể liên hệ với KH để giao
                  hàng, đơn hàng sẽ được xem là hủy, và đơn vị CPN sẽ hoàn trả
                  sản phẩm lại cho Tomotek.
                </li>
                <li>
                  Tomotek sẽ hoàn trả lại số tiền phí dịch vụ cho KH trong vòng
                  tối đa 7 ngày làm việc, kể từ ngày Tomotek nhận được hàng hoàn
                  trả từ đơn vị CPN.
                </li>
              </ul>
            </li>
            <li>
              <strong>Bảo hành phần cứng Loa thanh toán:</strong>
              <ul>
                <li>
                  Tomotek có trách nhiệm bảo hành 1 đổi 1 loa thanh toán trọn
                  đời khi KH còn sử dụng dịch vụ Loa thanh toán của Tomotek.
                </li>
                <li>
                  KH được Tomotek bảo hành 1 đổi 1 loa thanh toán trọn đời dịch
                  vụ.
                </li>
              </ul>
            </li>
            <li>
              <strong>Bảo hành từ xa:</strong>
              <ul>
                <li>
                  Tomotek có trách nhiệm trả lời hướng dẫn sửa chữa thông qua
                  Hotline của Tomotek.
                </li>
                <li>
                  KH cần liên hệ với Hotline của Tomotek khi có bất kỳ lỗi từ
                  phần cứng và phần mềm của Loa thanh toán và phối hợp theo
                  hướng dẫn đại diện chăm sóc KH trên Hotline.
                </li>
              </ul>
            </li>
            <li>
              <strong>Đổi trả:</strong>
              <ul>
                <li>
                  Khi bảo hành từ xa không khắc phục được, Tomotek sẽ gửi 1
                  thiết bị tương đương qua đơn vị chuyển phát đến KH. Phí chuyển
                  phát nhanh thiết bị được quy định như sau:
                </li>
                <li>
                  <strong>Trường hợp 1 - Đổi mới thiết bị:</strong>
                  <ul>
                    <li>
                      Khi KH nhận hàng qua CPN, KH được thực hiện mở hàng kiểm
                      tra và kết nối. Tomotek chịu toàn bộ chi phí đổi trả 2
                      chiều cho KH nếu thiết bị không hoạt động. Tomotek sẽ chịu
                      toàn bộ phí CPN đổi trả 2 chiều.
                    </li>
                    <li>
                      <strong>Điều kiện đổi trả sản phẩm:</strong>
                      <ul>
                        <li>
                          KH quay lại video clip quá trình mở kiện hàng để làm
                          bằng chứng khi có khiếu nại xảy ra (nếu KH đã nhận
                          được hàng).
                        </li>
                        <li>
                          KH quay lại video clip quá trình đóng gói sản phẩm kèm
                          đầy đủ phụ kiện, quà tặng, mút xốp, bóng khí (nếu có)
                          để đảm bảo hàng nguyên vẹn khi vận chuyển (nếu KH đã
                          nhận được hàng).
                        </li>
                        <li>
                          Sản phẩm đổi phải giữ nguyên 100% hình dạng ban đầu,
                          thân máy và màn hình sản phẩm (nếu có) không bị trầy
                          xước cong vênh.
                        </li>
                        <li>Hoàn trả lại đầy đủ hộp, sạc, phụ kiện đi kèm.</li>
                        <li>
                          Hoàn trả sản phẩm cho đơn vị vận chuyển ngay tại thời
                          điểm nhận hàng.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Trường hợp 2 - Đổi trả bảo hành:</strong>
                  <ul>
                    <li>
                      Trường hợp KH đã sử dụng một thời gian nhưng gặp lỗi, đã
                      liên hệ hotline bảo hành từ xa nhưng không xử lý được lỗi,
                      KH sẽ thực hiện chuyển lại thiết bị cho Tomotek bảo hành.
                      KH chịu phí CPN chiều đi. Tomotek chịu phí CPN chiều đến
                      KH.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
        </main>
        <footer class="modal-footer w-100">
          <button
            class="button-secondary w-100"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            Đã hiểu
          </button>
        </footer>
      </section>
    </div>
  </div>
</div>

<div *ngIf="isLoading" class="loading-overlay">
  <div
    class="spinner-border text-light"
    role="status"
    style="width: 3rem; height: 3rem"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
  <p class="mt-3 text-white">Đang tải dữ liệu...</p>
</div>
